export const IMAGE_FILE_EXTENSIONS = ['png', 'jpg', 'jpeg'];
export const DOCUMENT_FILE_EXTENSIONS = ['pdf', 'doc'];
